// Copyright 2019 Sorama B.V.

import { bindable, computedFrom, customElement } from "aurelia-framework";
import { WorkflowModuleNotificationInstance } from "libraries/WorkflowFramework/WorkflowModule/WorkflowModuleNotification";
import { NotificationUrgency } from "services/Notification/INotificationService";

@customElement("module-notification")
export class ModuleNotification {
    @bindable
    public notification: WorkflowModuleNotificationInstance;

    @computedFrom("notification")
    public get alertType(): string {
        switch (this.notification.notification.urgency) {
            case NotificationUrgency.Info:
                return "alert-info";
            case NotificationUrgency.Warning:
                return "alert-warning";
            case NotificationUrgency.Error:
                return "alert-danger";
        }
    }

    @computedFrom("notification")
    public get alertIcon(): string {
        switch (this.notification.notification.urgency) {
            case NotificationUrgency.Info:
                return "fas fa-info-circle";
            case NotificationUrgency.Warning:
                return "fas fa-exclamation-triangle";
            case NotificationUrgency.Error:
                return "fas fa-exclamation-triangle";
        }
    }

    public buttonPressed(callback: () => void): void {
        if (callback) {
            callback();
        }
        this.close();
    }

    public close(): void {
        this.notification.close();
    }
}
